import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import { getBusinessPalette } from './businessPalette';

export const CategoryHeader = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    padding: theme.spacing(1.2, 3),
    margin: theme.spacing(0, 1),
    background: palette.categoryHeaderBg,
    borderRadius: '12px',
    textAlign: 'left',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 10,
    border: '1.2px solid #7b7d7b',
    boxShadow: 'none',
    overflow: 'hidden',
    '&:hover': {
      background: palette.categoryHeaderHoverBg,
      border: `1px solid ${palette.categoryHeaderBorderHover}`,
    },
    '&:active': {
      background: palette.categoryHeaderActiveBg,
      borderRadius: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.2, 3),
    },
  };
});

export const ServiceItem = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'businessId',
})(({ theme, selected, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    padding: theme.spacing(1.2, 3),
    background: selected ? palette.serviceItemSelectedBg : '#FFFFFF',
    borderRadius: '12px',
    textAlign: 'left',
    cursor: 'pointer',
    display: 'flex',
    maxWidth: '85%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    margin: theme.spacing(1, 'auto'),
    border: selected
      ? `2.3px solid ${palette.serviceItemSelectedBorder}`
      : `1.8px solid ${palette.serviceItemBorder}`,
    boxShadow: 'none',
    '&:hover': {
      borderRadius: '12px',
      boxShadow: 'none',
    },
    '&:active': {
      borderRadius: '12px',
      boxShadow: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5, 3),
      '&:hover': {
        borderRadius: '12px',
        boxShadow: 'none',
      },
      '&:active': {
        borderRadius: '12px',
        boxShadow: 'none',
      },
    },
  };
});

export const CategoryText = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontSize: '1.4rem',
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem',
  },
}));

export const ServiceTextBlack = styled(Typography)(({ theme }) => ({
  color: 'black',
  fontSize: '1.4rem',
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem',
  },
}));

export const ServiceText = styled(Typography)(({ theme }) => ({
  color: '#555',
  fontSize: '1rem',
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9rem',
  },
}));

export const ServiceListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const ExpandIcon = styled('div', {
  shouldForwardProp: (prop) => prop !== 'expanded' && prop !== 'businessId',
})(({ expanded, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    width: '28px',
    height: '28px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: expanded
      ? palette.expandIconExpandedBg
      : palette.expandIconBg,
    transition: 'background-color 0.3s ease, transform 0.3s ease',
  };
});